import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import instance from "../utils/axiosInstance";

const Login = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [metaLoading, setMetaLoading] = useState(false);

  useEffect(() => {
    instance
      .get("/user/me", { withCredentials: true })
      .then((res) => {
        setUser(res.data.user);
        navigate("/profile");
      })
      .catch(() => {
        setUser(null);
      });
  }, [setUser, navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const res = await instance.post(
        "/user/login",
        { email, password },
        { withCredentials: true }
      );
      setUser(res.data.user);
      setError("");
      navigate("/");
    } catch (error) {
      setError(error.response?.data?.message || "로그인 실패");
    } finally {
      setLoading(false);
    }
  };

  const handleMetaLogin = async () => {
    try {
      setMetaLoading(true);
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const address = accounts[0];
      const res = await instance.post("/user/metamask-login", { address }, { withCredentials: true });
      setUser(res.data.user);
      navigate("/profile");
    } catch (err) {
      alert(err.response?.data?.message || "로그인 실패");
    } finally {
      setMetaLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={(theme) => ({
        mt: 10,
        px: 4,
        py: 6,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      })}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom color="text.primary">
        로그인
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleLogin}>
        <TextField
          label="이메일"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          required
        />
        <TextField
          label="비밀번호"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError("");
          }}
          required
        />
        <Button
          variant="contained"
          type="submit"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "로그인"}
        </Button>
      </form>

      <Box sx={{ my: 3 }}>
        <Divider>또는</Divider>
      </Box>

      <Button
        variant="outlined"
        fullWidth
        onClick={handleMetaLogin}
        disabled={metaLoading}
      >
        {metaLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "🦊 메타마스크 로그인"
        )}
      </Button>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          계정이 없으신가요?{" "}
          <Link to="/register" style={{ textDecoration: "none", color: "#6B4F3B", fontWeight: 600 }}>
            회원가입
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Login;
